<template>
  <div>
    <Over2charts class="chart" :options="chartOptions" :updateArgs="updateArgs" ref="overchart2"></Over2charts>
  </div>
</template>

<script>
import axios from "axios";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import drilldownInit from "highcharts/modules/drilldown";
import exportingInit from "highcharts/modules/exporting";
import stockInit from "highcharts/modules/stock";
import { EventBus } from "@/event-bus.js";

stockInit(Highcharts);
exportingInit(Highcharts);
drilldownInit(Highcharts);

Highcharts.setOptions({
  lang: {
    decimalPoint: ".",
    thousandsSep: ","
  }
});

var topLevel = [],
  secondLevel = [],
  secondLevelData1 = [],
  secondLevelData2 = [],
  secondLevelData3 = [],
  secondLevelData4 = [];

export default {
  props: {
    partsdata: {
      type: Array
    }
  },

  components: {
    Over2charts: Chart
  },

  created() {
    EventBus.$on("btn-clicked", data => {
      this.chartOptions.series[0].data = data.newData;
      this.chartOptions.drilldown.series[0].data = data.newSecondLevelData1;
      this.chartOptions.drilldown.series[1].data = data.newSecondLevelData2;
      this.chartOptions.drilldown.series[2].data = data.newSecondLevelData3;
      this.chartOptions.drilldown.series[3].data = data.newSecondLevelData4;
    });
  },

  data() {
    return {
      updateArgs: [true, true, true],
      topLevel: [],
      secondLevel: [],
      items: null,
      loading: true,
      errored: false,
      chartOptions: {
        chart: {
          type: "pie"
        },
        title: {
          text: "Global Non-CO₂ Emissions by Gas (MtCO₂e)"
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: "{point.name}: {point.y:.1f}"
            }
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b><br/>'
        },
        series: [
          {
            name: "Sectors",
            colorByPoint: true,
            data: topLevel
          }
        ],
        drilldown: {
          series: secondLevel
        }
      }
    };
  },
  mounted() {
    axios
      .get(
        "https://appdev4.erg.com/nonco2/reports/static/nonco2-2015-2050formated.json"
      )
      .then(response => {
        if (topLevel.length) {
          topLevel = [];
        }
        if (secondLevelData1.length) {
          secondLevelData1 = [];
        }
        if (secondLevelData2.length) {
          secondLevelData2 = [];
        }
        if (secondLevelData3.length) {
          secondLevelData3 = [];
        }
        if (secondLevelData4.length) {
          secondLevelData4 = [];
        }
        if (secondLevel.length) {
          secondLevel = [
            {
              name: "agriculture",
              id: "agriculture",
              data: secondLevelData1
            },
            {
              name: "energy",
              id: "energy",
              data: secondLevelData2
            },
            {
              name: "industrial processes",
              id: "industrial processes",
              data: secondLevelData3
            },
            {
              name: "waste",
              id: "waste",
              data: secondLevelData4
            }
          ];
        }

        this.items = response.data.results[0].items;
        var sectorName, categoryName;

        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].data_year === 2015) {
            sectorName = this.items[i].sector.toLowerCase();
            categoryName = this.items[i].category_details.toLowerCase();

            if (sectorName === categoryName) {
              topLevel.push({
                name: this.items[i].category_details,
                y: this.items[i].emis_data,
                drilldown: sectorName
              });
            }

            if (
              sectorName === "agriculture" &&
              this.items[i].category_id !== 100
            ) {
              secondLevelData1.push([
                this.items[i].category_details,
                this.items[i].emis_data
              ]);
            }

            if (sectorName === "energy" && this.items[i].category_id !== 200) {
              secondLevelData2.push([
                this.items[i].category_details,
                this.items[i].emis_data
              ]);
            }

            if (
              sectorName === "industrial processes" &&
              this.items[i].category_id !== 300
            ) {
              secondLevelData3.push([
                this.items[i].category_details,
                this.items[i].emis_data
              ]);
            }

            if (sectorName === "waste" && this.items[i].category_id !== 400) {
              secondLevelData4.push([
                this.items[i].category_details,
                this.items[i].emis_data
              ]);
            }
          }
        }
      })
      .catch(error => {
        console.log(error);
        this.errored = true;
      })
      .finally(() => (this.loading = false));
  }
};

secondLevel = [
  {
    name: "agriculture",
    id: "agriculture",
    data: secondLevelData1
  },
  {
    name: "energy",
    id: "energy",
    data: secondLevelData2
  },
  {
    name: "industrial processes",
    id: "industrial processes",
    data: secondLevelData3
  },
  {
    name: "waste",
    id: "waste",
    data: secondLevelData4
  }
];
</script>
